import { copy, module } from 'angular';
import { StateRegistry, StateDeclaration } from '@uirouter/core';
import { INestedState } from './state.provider';

export class StateHelper implements ng.IServiceProvider {

  private registeredStates: string[] = [];

  constructor(private $stateRegistryProvider: StateRegistry) { 'ngInject'; }

  public setNestedState(state: INestedState, keepOriginalNames = false) {
    const newState: INestedState = copy(state);
    if (!keepOriginalNames) {
      this.fixStateName(newState);
      this.fixStateViews(newState);
      newState.parent = null;
    }
    if (!this.registeredStates.includes(newState.name)) {
      this.registeredStates.push(newState.name);
      this.$stateRegistryProvider.register(newState as StateDeclaration);
    }

    if (newState.children && newState.children.length) {
      newState.children.forEach((childState: INestedState) => {
        childState.parent = newState.name;
        this.setNestedState(childState, keepOriginalNames);
      });
    }
  };

  private fixStateName(state: INestedState) {
    if (state.parent) {
      state.name = `${state.parent}.${state.name}`;
    }
  }

  private fixStateViews(state: INestedState) {
    const views = state.views || {},
        replaced: string[] = [];
    Object.keys(views).forEach((key) => {
      const relative: RegExpMatchArray = key.match('../');
      if (relative && relative.length && typeof state.parent === 'string') {
        const relativePath: string = state.parent.split('.').slice(0, -1 - relative.length).join('.') + '.';
        views[key.replace(/(..\/)+/, relativePath)] = views[key];
        replaced.push(key);
      }
    });
    replaced.forEach((key) => delete views[key]);
  }

  public $get(): StateHelper {
    return this;
  }
}

export const STATE_HELPER = 'spinnaker.core.navigation.stateHelper.provider';
module(STATE_HELPER, []).provider('stateHelper', StateHelper);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/navigation/stateHelper.provider.ts